<style lang="scss">
.app-header {
  padding: 1rem 2rem;
  background-color: color(primary);

  &__exchange-rates {
    color: white;
    font-size: 5rem;

    .currency {
      font-weight: bold;
    }

    .change-icon {
      margin-left: 1rem;
      width: 2.5rem;
    }
  }

  &__logo-vesper {
    .image {
      .image__el {
        height: 3.5rem;
      }
    }
  }
}
</style>

<template>
  <div class="app-header flex items-center justify-between">
    <div class="app-header__exchange-rates flex items-center">
      <div
        v-for="currency in currencies"
        :key="currency"
        class="flex flex-row items-center justify-start mr-12"
      >
        <span class="currency mr-3">{{ currency }}</span>
        <span class="rate">{{ exchangeRates[currency] | formatNumbers(4) }}</span>
        <img
          class="change-icon"
          :src="exchangeRateChangeIcon(currency)"
        >
      </div>
    </div>
    <div class="app-header__logo-vesper flex items-center justify-center">
      <v-image
        :src="require('@/assets/img/logo.svg')"
        alt="Vesper"
      />
    </div>
  </div>
</template>

<script>
import { LoadsDataMixin } from '@/mixins/LoadsDataMixin';
import moment from 'moment';
import { openExchangeRates } from '@/integrations';

export default {
  name: 'VHeader',
  mixins: [
    LoadsDataMixin,
  ],
  data() {
    return {
      exchangeRates: {},
      previousRates: {},
      baseCurrency: 'EUR',
      currencies: [
        'USD',
        'GBP',
        'PLN',
        'CHF',
      ],
    };
  },
  computed: {
    hasData() {
      return Object.keys(this.exchangeRates).length > 0;
    },
  },
  methods: {
    async loadData() {
      await Promise.all([
        this.loadCurrentRate(),
        this.loadPreviousRate(),
      ]);
    },
    async loadCurrentRate() {
      const { data } = await openExchangeRates.latest(this.baseCurrency);
      this.exchangeRates = data.rates;
    },
    async loadPreviousRate() {
      const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');

      const { data } = await openExchangeRates.historical(
        yesterday,
        this.baseCurrency,
        this.currencies,
      );

      this.previousRates = data.rates;
    },
    exchangeRateChange(currency) {
      const current = this.exchangeRates[currency];
      const previous = this.previousRates[currency];

      return current - previous;
    },
    exchangeRateChangeIcon(currency) {
      const change = this.exchangeRateChange(currency);

      if (change > 0) {
        return require('@/assets/img/ico-arrow-positive.svg');
      }

      if (change < 0) {
        return require('@/assets/img/ico-arrow-negative.svg');
      }

      return require('@/assets/img/ico-arrow-neutral.svg');
    },
  },
};
</script>
